import { ArrowRight, Check, ExternalLink } from "lucide-react";
import { PRODUCTS, COLORS } from "@/lib/site";
import { Reveal } from "@/components/Reveal";

export default function Products() {
  return (
    <div data-testid="products-page">
      <section className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
          <Reveal>
            <div className="inline-flex items-center gap-2 text-sm font-medium mb-5 px-3 py-1 rounded-full" style={{ backgroundColor: "#E7F3EC", color: COLORS.green }}>
              Software for Indian MSMEs
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-[#1A1A1A]">Our products</h1>
            <p className="mt-5 text-base md:text-lg text-slate-600 max-w-2xl leading-relaxed">
              Affordable, easy-to-use software for small businesses. Every product is live today,
              runs on its own site, and comes with a 14-day free trial — no credit card needed.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#FDFCF0]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-20 space-y-8">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.key} delay={i * 0.05}>
              <div className="bg-white rounded-md border border-gray-200 overflow-hidden grid md:grid-cols-2" data-testid={`product-block-${p.key}`}>
                <img src={p.img} alt={p.name} className={`h-56 md:h-full w-full object-cover ${i % 2 === 1 ? "md:order-2" : ""}`} />
                <div className="p-8 md:p-10 flex flex-col">
                  <div className="text-xs font-medium uppercase tracking-wide" style={{ color: COLORS.green }}>{p.tag}</div>
                  <div className="mt-2 flex items-center gap-2">
                    <p.icon size={24} style={{ color: COLORS.blue }} />
                    <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A1A]">{p.name}</h2>
                  </div>
                  <p className="mt-4 text-slate-600 leading-relaxed">{p.long}</p>
                  <ul className="mt-5 space-y-2">
                    {p.features.map((f) => (
                      <li key={f} className="flex gap-2 text-slate-700">
                        <Check size={18} style={{ color: COLORS.green }} className="shrink-0 mt-1" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-7 flex flex-wrap items-center gap-4">
                    <a href={p.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-md px-6 py-3 text-white font-medium transition-colors duration-150 hover:opacity-90" style={{ backgroundColor: COLORS.blue }} data-testid={`product-visit-${p.key}`}>
                      Visit {p.name} <ExternalLink size={16} />
                    </a>
                    <span className="text-sm text-slate-500">14-day free trial · no credit card</span>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-white border-t border-gray-200" data-testid="products-note">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 text-sm text-slate-500 flex items-start gap-2">
          <ArrowRight size={16} className="mt-1 shrink-0" />
          <p>Pricing and sign-up for each product are on its own website. Clicking a product opens its site in a new tab.</p>
        </div>
      </section>
    </div>
  );
}
